import * as React from 'react';
import Icons from '../icons';

export default class Emptynotes extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptynote" className="" />    
                <h2>No notes found</h2>
                {
                    this.props.type
                    &&
                    <p>All notes related to the {this.props.type} would be available here.</p>
                }
            </div>
        );
    }
}